export default async function GetUser({ username }) {

    const url = "https://gops.azulhandling.com/LoginPage/procesos_seguros/getUser.php";
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': localStorage.getItem('token')
        },
        body: JSON.stringify({
            username
        }),
    })

    if (res.status == 200) {
        return await res.json()
    } else {
        return "Error obteniendo los datos"
    }
}